import type { ProductBundle } from "@wbly/data-storefront";
import { Button } from "@wbly/ui";
import { getLocaleUrl } from "@wbly/common";
import styles from "../Bundles.module.css";

type BundleProps = ProductBundle & {
  marketplace: string;
};

const {
  header,
  headerTitle,
  product,
  productContent,
  productImage,
  productList,
  productTitle,
} = styles;

export function Bundle({
  title,
  description,
  productLinks,
  bundleCtaText,
  marketplace,
}: BundleProps) {
  return (
    <div>
      <div className={header}>
        <h2
          className={headerTitle}
          dangerouslySetInnerHTML={{ __html: title }}
        ></h2>
        <p>{description}</p>
      </div>

      {productLinks?.length > 0 && (
        <div className={productList}>
          {productLinks.map(({ slug, title, description, image }) => (
            <div key={slug} className={product}>
              <img className={productImage} src={image.src} />

              <div className={productContent}>
                <h3 className={productTitle}>{title}</h3>
                <p>{description}</p>

                {slug && (
                  <Button
                    variant="secondary"
                    as="a"
                    href={getLocaleUrl(
                      marketplace,
                      `/personalized-products/${slug}`
                    )}
                  >
                    {bundleCtaText}
                  </Button>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
